/**
 * API client for the template, Excel-bridge and branding endpoints. Other pages call
 * axios directly against BACKEND_URL. Auth (credentials, token) comes from the axios
 * defaults that AuthContext sets.
 */
import axios from "axios";
import { BACKEND_URL } from "../lib/config";

const api = {
  // ── Templates ────────────────────────────────────────────────────────────
  getTemplate: (id) => axios.get(`${BACKEND_URL}/api/templates/${id}`),

  // ── Excel → Template Bridge ──────────────────────────────────────────────
  placeholdersFromExcel: (formData) =>
    axios.post(`${BACKEND_URL}/api/templates/placeholders-from-excel`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  applyExcelPlaceholders: (formData) =>
    axios.post(`${BACKEND_URL}/api/admin/templates/apply-excel-placeholders`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  // ── Branding (logo & authorized signatory) ──────────────────────────────
  // Public endpoint used by the unauthenticated login page.
  getPublicLogo: () => axios.get(`${BACKEND_URL}/api/branding/logo`),
  getBranding: () => axios.get(`${BACKEND_URL}/api/admin/branding`),

  uploadLogo: (formData) =>
    axios.put(`${BACKEND_URL}/api/admin/branding/logo`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  uploadSignatory: (formData) =>
    axios.put(`${BACKEND_URL}/api/admin/branding/signatory`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  updateSizes: (sizes) =>
    axios.put(`${BACKEND_URL}/api/admin/branding/sizes`, sizes),

  removeLogo: () => axios.delete(`${BACKEND_URL}/api/admin/branding/logo`),

  removeSignatory: () => axios.delete(`${BACKEND_URL}/api/admin/branding/signatory`),
};

export default api;
